import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel, StatusPill } from "@/components/Peep";

const PROVIDERS = [
  { name: "CCBill", fit: "Strong fit", model: "Specialist IPSP / merchant of record for 18+ creator & subscription sites.",
    recurring: "Yes — native recurring + tokenized rebills", disputes: "Refunds, chargeback & dispute tooling", payouts: "Platform collects; multi-creator payout/split support must be confirmed in onboarding",
    compliance: "Legal entity, business bank account, age gate, ToS/Privacy/Refund policies, content review; high-risk fee tier (≈10–14%)" },
  { name: "Segpay", fit: "Strong fit", model: "Specialist processor for digital content subscriptions, including 18+.",
    recurring: "Yes — subscription billing focus", disputes: "Strong chargeback/fraud management", payouts: "Platform collects; creator payout handling to confirm",
    compliance: "High-risk underwriting, KYC/KYB, live compliant site before approval" },
  { name: "Verotel", fit: "Good fit (EU-heavy audiences)", model: "EU-based specialist processor for 18+ digital content.",
    recurring: "Yes (FlexPay)", disputes: "Refunds & chargebacks supported", payouts: "Platform collects; confirm marketplace payouts",
    compliance: "KYB, site review, policies; strong SEPA support" },
  { name: "Stripe", fit: "High risk — not recommended", model: "Mainstream PSP. Restricted-business list prohibits adult content/services; 18+ fan platforms are frequently terminated even when non-explicit.",
    recurring: "Yes", disputes: "Yes", payouts: "Stripe Connect (if eligible)", compliance: "Account closure / fund holds possible if classified as restricted" },
  { name: "Square / PayPal / Razorpay", fit: "Not recommended", model: "Mainstream processors with adult/sexually-oriented restrictions.",
    recurring: "Varies", disputes: "Yes", payouts: "Limited marketplace support", compliance: "Policy risk for this business model" },
];

export default function AdminProvider() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/provider").then((r) => setD(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="admin-provider" className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-extrabold">Payment provider eligibility</h1>
        <p className="mt-1 text-sm text-[#a7a0af]">Awaiting your selection. No live processor is active — PEEPING PAY runs on the sandbox adapter.</p>
      </div>
      {d && (
        <Panel title="Current adapter">
          <div className="flex flex-wrap items-center gap-3 text-sm">
            <StatusPill status={d.live ? "live" : "sandbox"} testid="provider-mode" />
            <span className="text-[#c7c1cf]">Adapter: <b>{d.mode}</b> · Webhook endpoint: <code className="text-xs">{d.webhook_endpoint}</code></span>
          </div>
        </Panel>
      )}
      <div className="grid gap-3 lg:grid-cols-2">
        {PROVIDERS.map((p) => (
          <Panel key={p.name} title={p.name} action={<span className="text-xs text-[#f0a8fa]">{p.fit}</span>} data-testid={`provider-${p.name.split(" ")[0].toLowerCase()}`}>
            <dl className="flex flex-col gap-2 text-xs text-[#c7c1cf]">
              <div><dt className="text-[#a7a0af]">Business model</dt><dd>{p.model}</dd></div>
              <div><dt className="text-[#a7a0af]">Recurring billing</dt><dd>{p.recurring}</dd></div>
              <div><dt className="text-[#a7a0af]">Refunds & chargebacks</dt><dd>{p.disputes}</dd></div>
              <div><dt className="text-[#a7a0af]">Platform collection & creator payouts</dt><dd>{p.payouts}</dd></div>
              <div><dt className="text-[#a7a0af]">Merchant verification & compliance</dt><dd>{p.compliance}</dd></div>
            </dl>
          </Panel>
        ))}
      </div>
      <p className="text-xs text-[#6f6878]">Based on publicly available policies; every provider makes the final eligibility decision during underwriting. Confirm terms directly before activation.</p>
    </div>
  );
}
